const targets = document.querySelectorAll(
  '.your-class, #shopify-section-template--21335853367493__section_adCemH h2, #shopify-section-template--21335853367493__section_adCemH p, #shopify-section-template--21335853367493__1774907993df74b22c, #home-hero-grid .artem-split-grid__cell-text, #home-atelier-approach h2, #home-atelier-approach .text-block, #home-atelier-approach .custom-liquid '
);

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.15 });

targets.forEach(el => observer.observe(el));